/*
 * Borrowed with love from from dagre-d3. Many thanks to cpettitt!
 */

import node from './intersect-node.js';
import circle from './intersect-circle.js';
import ellipse from './intersect-ellipse.js';
import polygon from './intersect-polygon.js';
import rect from './intersect-rect.js';

export default {
  node,
  circle,
  ellipse,
  polygon,
  rect,
};
